// extracted by mini-css-extract-plugin
module.exports = {"list":"Inventory_list__3EwmW"};